import React from 'react';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard, 
  CCardHeader, CCardBody, CRow, CCol } from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import ShipmentInputs from '../../components/ShipmentInputs/ShipmentInputs';
import { updateShipmentRequest } from '../../store/shipment/shipmentActions';

const UpdateShipment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isLoading = useSelector(state => state.shipmentReducer.isLoading);
  const submitResponse = useSelector(state => state.shipmentReducer.updateShipmentData);
  const initialData = location.state?.shipment || null;

  const handleSubmit = (data) => {
    dispatch(updateShipmentRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/shipments');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/shipments" onClick={e => 
          { e.preventDefault(); handleCancel(); }}>{t('shipments')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateShipment')}</CBreadcrumbItem>
      </CBreadcrumb>
      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('updateShipment')}</h4></CCardHeader>
            <CCardBody>
              <ShipmentInputs onSubmit={handleSubmit} 
              onCancel={handleCancel} isLoading={isLoading} 
              submitResponse={submitResponse} initialData={initialData} isEdit />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

export default UpdateShipment; 